const steps = [
  {
    step: '01',
    icon: 'ri-search-2-line',
    title: 'Assess Your Needs',
    description: 'Use our solar savings calculator to estimate your system size and expected savings based on your location, energy usage, and roof type. Our tools help you understand exactly what you need before speaking to anyone.',
    detail: 'Free online assessment — no obligation',
    color: 'bg-primary-500',
  },
  {
    step: '02',
    icon: 'ri-scales-line',
    title: 'Compare Providers',
    description: "Browse AK Energy's marketplace of CEC-accredited installers and verified renewable energy providers. Filter by location, system type, reviews, and certifications to find the right match for your project.",
    detail: 'Verified reviews & certifications',
    color: 'bg-accent-600',
  },
  {
    step: '03',
    icon: 'ri-message-2-line',
    title: 'Connect & Get Quotes',
    description: 'Request quotes from multiple providers through AK Energy. Our trusted installers will assess your site, provide a detailed proposal, and answer any questions — with no pressure and full transparency on costs.',
    detail: 'Multiple quotes in one request',
    color: 'bg-primary-500',
  },
  {
    step: '04',
    icon: 'ri-tools-line',
    title: 'Install & Start Saving',
    description: "Your chosen provider manages everything — permits, grid connection, installation, and commissioning. Most residential installations are completed in one day. You'll be generating clean solar energy within days.",
    detail: 'Typically installed in 1–2 days',
    color: 'bg-accent-600',
  },
];

export default function SolarProcess() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 mb-5">
            <i className="ri-road-map-line text-primary-500 text-sm"></i>
            <span className="text-xs font-semibold text-primary-700 tracking-wide uppercase whitespace-nowrap">How It Works</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4">
            Your Solar Journey,<br className="hidden md:block" /> Made Simple
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            From assessing your energy needs to having solar panels generating clean electricity — AK Energy simplifies every step of the solar process.
          </p>
        </div>

        <div className="relative">
          {/* Connector line on desktop */}
          <div className="hidden lg:block absolute top-12 left-[calc(12.5%)] right-[calc(12.5%)] h-px bg-gradient-to-r from-primary-200 via-accent-300 to-primary-200 z-0" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 relative z-10">
            {steps.map((step, idx) => (
              <div key={step.step} className="flex flex-col items-center text-center" style={{ animationDelay: `${idx * 0.1}s` }}>
                {/* Step circle */}
                <div className={`relative w-24 h-24 rounded-2xl ${step.color} flex flex-col items-center justify-center mb-6 shadow-sm`}>
                  <i className={`${step.icon} text-2xl text-white mb-1`}></i>
                  <span className="text-xs font-bold text-white/70">{step.step}</span>
                </div>

                <h3 className="font-heading text-base font-bold text-foreground-950 mb-3">{step.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{step.description}</p>
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600">
                  <i className="ri-check-double-line"></i>
                  {step.detail}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 text-center">
          <a
            href="/#solar-calculator"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-calculator-line text-lg"></i>
            Start with the Solar Calculator
          </a>
        </div>
      </div>
    </section>
  );
}